const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_CODE: '/register/:code',
  REDEEM_REWARDS: '/redeem-rewards',
  TRANSACTION_HISTORY: '/transaction-history',
  PROFILE: '/profile',
  EDIT_PROFILE: '/edit-profile',
  CONTACT_US: '/contact-us',
  SHARE_CODE: '/share-code',
  
};

export default ROUTES;